var map = {
	"./gallery_00.jpg": 1861,
	"./gallery_01.jpg": 1862,
	"./gallery_02.jpg": 1863,
	"./gallery_03.jpg": 1864,
	"./gallery_04.jpg": 1865,
	"./gallery_05.jpg": 1866,
	"./gallery_06.jpg": 1867,
	"./gallery_07.jpg": 1868,
	"./gallery_08.jpg": 1869,
	"./gallery_09.jpg": 1870
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1860;